import React from 'react';
import { AppBar, Breadcrumbs, Toolbar, Tooltip } from '@mui/material';
import { GridIcon } from '../components/Icon';

function HeaderBar() {
  return (
    <AppBar position='static' elevation={1}  color={'secondary'} style={{ height: '50px', zIndex:10}}>
      <Toolbar variant='dense'>
        <Breadcrumbs color={'primary.dark'}>
          <h1>Score</h1>
        </Breadcrumbs>
        <Breadcrumbs style={{ marginLeft: 'auto' }}>
          <Tooltip title={'Not yet implemented'}>
            <GridIcon />
          </Tooltip>
        </Breadcrumbs>
      </Toolbar>
    </AppBar>
  );
}

export default HeaderBar;
